import { AppData } from "../../types";
import { Mixpanel } from "../../../mixpanel";

export type BackFromServicesStepOpts = {
  appData: AppData;
};

// Really simple—the only step which can *ever* precede Services is Organisation
// so just set the currentStep accordingly.
export const backFromServicesStep = ({
  appData,
}: BackFromServicesStepOpts): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "services" } });
  return {
    ...appData,
    currentStep: "organisations",
  };
};
